// Promociones configurables
export const FREE_SHIPPING_THRESHOLD = 300000;

export const WHOLESALE_TIERS = [
  { threshold: 500000, discount: 0.10 },
  { threshold: 300000, discount: 0.05 },
];

export const WELCOME_DISCOUNT = 0.05; // 5% extra primer pedido para clientes registrados

export const WHATSAPP_NUMBER = "5491124722683";

export const getActiveTier = (subtotal) => {
  for (const tier of WHOLESALE_TIERS) {
    if (subtotal >= tier.threshold) return tier;
  }
  return null;
};

export const getNextTier = (subtotal) => {
  const upcoming = [...WHOLESALE_TIERS]
    .filter((t) => t.threshold > subtotal)
    .sort((a, b) => a.threshold - b.threshold);
  return upcoming[0] || null;
};

export const computeCartPromo = (subtotal, options = {}) => {
  const { welcomeEligible = false } = options;

  const missingForShipping = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal);
  const freeShipping = subtotal >= FREE_SHIPPING_THRESHOLD;

  const activeTier = getActiveTier(subtotal);
  const nextTier = getNextTier(subtotal);
  const tierDiscount = activeTier ? subtotal * activeTier.discount : 0;
  const welcomeDiscount = welcomeEligible ? subtotal * WELCOME_DISCOUNT : 0;
  const discount = tierDiscount + welcomeDiscount;
  const total = subtotal - discount;

  return {
    missingForShipping,
    freeShipping,
    activeTier,
    nextTier,
    tierDiscount,
    welcomeDiscount,
    welcomeApplied: welcomeDiscount > 0,
    discount,
    total,
  };
};
